import type { Preparation } from './PreparationModels';

/** status_id del pedido en estado Picking (toolbar in_preparation) */
export const ORDER_STATUS_PICKING = 4;

export interface AdjustPickingDiscrepancyPayload {
  order_ids: number[];
  discrepancy: {
    product_id: number;
    location_id: number;
    qty: number;
  };
  reason?: string;
}

export interface StockReturnedFromCart {
  pick_id: number;
  product_id: number;
  qty_returned: number;
  from_bucket_location_id: number;
  from_bucket_location_code: string | null;
  to_source_location_id: number;
  to_source_location_code: string | null;
  batch_id: number | null;
}

export interface OrderRollbackResult {
  status: string;
  order_id: number;
  from_state: string;
  to_state: string;
  dry_run: boolean;
  effects: unknown[];
  details: Record<string, unknown>;
}

export interface AdjustPickingDiscrepancyResponse {
  status: 'ok';
  preparation_id: number;
  preview?: boolean;
  discrepancy: {
    product_id: number;
    location_id: number;
    qty: number;
    matching_pick_records_found_for_product_at_location: boolean;
  };
  order_rollbacks: OrderRollbackResult[];
  stock_returned_from_cart_to_locations: StockReturnedFromCart[];
  preparation: Preparation;
}

export interface InitialDiscrepancyContext {
  product_id: number;
  /** Ubicación de almacén donde se detectó el descuadre (no el carrito de preparación) */
  location_id?: number;
  qty?: number;
}
